<template>
    <div style="max-width: 600px;" class="mx-auto">
        <h3 class="text-center">Initial Loan Setup</h3>

        <v-simple-table dense>
            <template v-slot:default>
                <tbody>
                    <tr>
                        <td>Age of Youngest Borrower</td>
                        <td>{{ values.ageOfYoungestBorrower }}</td>
                    </tr>
                    <tr>
                        <td>Interest Rate (Expected/Initial)</td>
                        <td>{{ `${formatPercentage(values.interestRate.expected)} /
                            ${formatPercentage(values.interestRate.initial)}` }} </td>
                    </tr>
                    <tr>
                        <td>Maximum Claim Amount</td>
                        <td>{{ formatMoney(values.maximumClaimAmount) }}</td>

                    </tr>
                    <tr>
                        <td>Initial Principal Limit</td>
                        <td>{{ formatMoney(values.initialPrincipalLimit) }}</td>

                    </tr>
                    <tr>
                        <td>Cash Due To/ From Borrower</td>
                        <td>{{ formatMoney(values.cashDueToOrFromBorrower) }}</td>

                    </tr>
                    <tr>
                        <td>Lien Payoffs with Reverse Mortgage</td>
                        <td>{{ formatMoney(values.lienPayoffsWithReverseMortgage) }}</td>

                    </tr>
                    <tr>
                        <td>Financed Closing Costs</td>
                        <td>{{ formatMoney(values.financedClosingCosts) }}</td>

                    </tr>
                    <tr>
                        <td>Credit Applied</td>
                        <td>{{ formatMoney(values.creditApplied) }}</td>

                    </tr>
                    <tr>
                        <td>Initial Property Value</td>
                        <td>{{ formatMoney(values.initialPropertyValue) }}</td>

                    </tr>
                    <tr>
                        <td>Expected Appreciation</td>
                        <td>{{ formatPercentage(values.expectedAppreciation) }}</td>

                    </tr>
                    <tr>
                        <td>Beg. Mortgage Balance</td>
                        <td>{{ formatMoney(values.begMortgageBalance) }}</td>

                    </tr>
                    <tr>
                        <td>Initial Line of Credit</td>
                        <td>{{ formatMoney(values.initialLineOfCredit) }}</td>

                    </tr>
                    <tr>
                        <td>Monthly Payments to Borrower (Yr 1)</td>
                        <td>{{ formatMoney(values.monthlyPaymentToBorrower) }}</td>

                    </tr>
                    <tr>
                        <td>Voluntary Payments from Borrower (Yr 1)</td>
                        <td>{{ formatMoney(values.voluntaryPayments) }}</td>

                    </tr>
                    <tr>
                        <td>Monthly Servicing Fee</td>
                        <td>{{ formatMoney(values.monthlyServicingFee) }}</td>

                    </tr>
                    <tr>
                        <td>Mortgage Insurance (MIP)</td>
                        <td>{{ formatPercentage(values.mortgageInsuranceMIP) }}</td>

                    </tr>
                    <tr>
                        <td>Life Expectancy Set-Aside</td>
                        <td>{{ formatMoney(values.lifeExpectancySetAside) }}</td>
                    </tr>
                    <tr>
                        <td>LESA Semi-Annual Disbursement</td>
                        <td>{{ formatMoney(values.lesaSemiAnnualDisburseme) }}</td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </div>
</template>

<script>
import helpers from '../../helpers';

export default {
    methods: {
        formatMoney: helpers.formatMoney,
        formatPercentage: helpers.formatPercentage
    },
    computed: {
        values() {
            return this.$store.state.amortCompAndTALC.data.amortizationScheduleAnnualProjections;
        }
    },
};
</script>
